import React from 'react';
import CustomTd from '../shared/table/CustomTd';
import PropTypes from 'prop-types';
import SaveCancelButton from '../shared/buttons/SaveCancelButton';
import SelectList from '../shared/inputs/SelectList';
import useForm from '../../utilities/useForm';
import CurrencyInput from '../shared/inputs/CurrencyInput';

const AdAmountEditor = ({
    cancelEdit,
    disabled,
    fetchData,
    franchiseId,
    getUrl,
    item: initialItem,
    postUrl
}) => {
    const { item, ...form } = useForm(initialItem.id === 0 ? null : getUrl, postUrl, { item: initialItem });

    const submitForm = () => {
        form.submitData(() => {
            cancelEdit();
            fetchData();
        });
    }

    return (
        <tr>
            <CustomTd>
                <div style={{ height: '1.9em' }}>
                    <SelectList
                        lookupType="SubLeadSource"
                        name="subLeadSourceId"
                        onChange={form.formChange}
                        value={item.subLeadSourceId}
                        disabled={disabled}
                    />
                </div>
            </CustomTd>
            <CustomTd>
                <div style={{ height: '1.9em' }}>
                    <CurrencyInput
                        name="amount"
                        onChange={form.formChange}
                        placeholder="Amount"
                        required={!item.newItem}
                        validationError={item.amount_error}
                        value={item.amount}
                        disabled={disabled}
                    />
                </div>
            </CustomTd>
            <CustomTd className="button-cell">
                <SaveCancelButton
                    saveItem={submitForm}
                    cancelEdit={cancelEdit}
                    disabled={disabled}
                />
            </CustomTd>
        </tr>
    );
}

AdAmountEditor.propTypes = {
    cancelEdit: PropTypes.func,
    fetchData: PropTypes.func,
    getUrl: PropTypes.string.isRequired,
    postUrl: PropTypes.string.isRequired
};

export default AdAmountEditor;